import { render, staticRenderFns } from "./OwnersCrud.vue?vue&type=template&id=3597e574&scoped=true"
import script from "./OwnersCrud.vue?vue&type=script&lang=js"
export * from "./OwnersCrud.vue?vue&type=script&lang=js"
import style0 from "./OwnersCrud.vue?vue&type=style&index=0&id=3597e574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597e574",
  null
  
)

export default component.exports